import {Options, Print} from "@/plugins/print/lib/print";
import Vue from 'vue';

const VuePrint = {
    install(Vue, options = {}) {
        Vue.prototype.$print = function(printOptions: Options) {
            new Print(printOptions);
        };
        Vue.directive('print', {
            bind(el, binding, vnode) {
                const vue = vnode.context;
                let closeBtn = true;
                let id = '';
                const localPrint = () => {
                    if (closeBtn) {
                        closeBtn = false;
                        new Print({
                            id: id,
                            extraHead: binding.value.extraHead,
                            extraCss: binding.value.extraCss,
                            popTitle: binding.value.popTitle,
                            endCallback() {
                                closeBtn = true;
                            }
                        });
                    }
                };
                el.addEventListener('click', () => {
                    vue.$nextTick(() => {
                        if (typeof binding.value === 'string') {
                            id = binding.value;
                        } else if (typeof binding.value === 'object' && !!binding.value.id) {
                            id = binding.value.id;
                            const trueId = id.replace(new RegExp("#", "g"), '');
                            const elsdom = document.getElementById(trueId);
                            if (!elsdom) console.log("id in Error"), id = '';
                        }
                        if (id) {
                            localPrint();
                        } else {
                            window.print();
                        }
                    });

                });
            }
        })
    }
};
export default VuePrint;